export default __webpack_public_path__ + "static/hmcts-be97330bcf5e3cfd9998fa0e25a977f4.png";